import Q from 'q'

import data from './data/data.json'

/**
 * Set to 'true' to use the mock data response
 */
export const USE_MOCK_RESPONSE = false

let attachErrorCallback = null

export function init(callback) {
    attachErrorCallback = callback
}

/**
 * Use the data in the './data/data.json' as the response
 * @param {Object} request request object
 * @returns Promise of null if request does not match any key in data.json.
 * Will return Promise of actual response if status is less than 400.
 * Otherwise, will return a Promise.reject
 */
export const handleMockResponse = (request) => {
    if (!USE_MOCK_RESPONSE) {
        return Q(null)
    }

    const { method, url } = request

    const key = `${method.toLowerCase()}-${url.toLowerCase()}`

    if (!data[key])
        return Q(null)

    const { status, body, delay = 100 } = data[key]

    const defer = Q.defer()

    setTimeout(() => {
        if (status >= 400) {
            const result = Object.assign({
                response: {
                    status,
                    config: {
                        url,
                        method
                    },
                    data: body
                },
                message: `Request failed with status code ${status}`,
                stacktrace: body.trace || ''
            })
            attachErrorCallback(result)
            defer.reject(result)
        }
        else {
            defer.resolve({
                status,
                json: () => Q(body),
                config: {
                    url,
                    method
                }
            })
        }
    }, delay)

    return defer.promise
}


// WEBPACK FOOTER //
// src/services/core/mock-responses/index.js